import { doHttp } from '../utils/common'
import { HTTP_TYPE_GET, HTTP_TYPE_POST } from '../utils/config'

/**
 * 新增/编辑
 * @param params
 * @param companyId
 * @return {*}
 */
export function apiEdit (params, companyId) {
  return doHttp(`/property/addOrUpdate.action?companyId=${companyId}`, HTTP_TYPE_POST, params)
}

/**
 * 删除
 * @param id
 * @return {*}
 */
export function apiDelete (id) {
  let params = { id }
  return doHttp('/property/delete.action', HTTP_TYPE_GET, params)
}

/**
 * 详情
 * @param id
 * @return {*}
 */
export function apiDetail (id) {
  let params = { id }
  return doHttp('/property/detail.action', HTTP_TYPE_GET, params)
}

/**
 * 列表
 * @param companyId
 * @param name
 * @param pageIndex
 * @param pageSize
 * @return {*}
 */
export function apiList (companyId, name, pageIndex = 1, pageSize = 20) {
  let params = {
    companyId,
    name,
    pageIndex,
    pageSize
  }
  return doHttp('/property/list.action', HTTP_TYPE_GET, params)
}

/**
 * 列表
 * @param companyId
 * @param name
 * @param pageIndex
 * @param pageSize
 * @return {*}
 */
export function apiPropertyList (companyId, name, pageIndex = 1, pageSize = 20) {
  let params = {
    companyId,
    name,
    pageIndex,
    pageSize
  }
  return doHttp('/property/list.action', HTTP_TYPE_GET, params)
}
